import { useCallback, useMemo } from "react";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
const usePermissions = () => {
  const currentUser = useCurrentUser();
  const _isPermitted = useCallback(
    (permissions) => isPermitted(currentUser == null ? void 0 : currentUser.permissions, permissions),
    [currentUser == null ? void 0 : currentUser.permissions]
  );
  return useMemo(() => ({ isPermitted: _isPermitted }), [_isPermitted]);
};
export default usePermissions;
